"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionEntityIdForType = exports.cacheExtensionsCollectionTypename = void 0;
exports.cacheExtensionsCollectionTypename = 'CacheExtensionsCollectionEntity';
function collectionEntityIdForType(typename) {
    return `${exports.cacheExtensionsCollectionTypename}:${typename}`;
}
exports.collectionEntityIdForType = collectionEntityIdForType;
//# sourceMappingURL=utils.js.map